import React from 'react';
import { useFusionAuth } from '@fusionauth/react-sdk';
import ConfigurableBaseExplorer from '../baseExplorer/ConfigurableBaseExplorer';
import ContextHelp from '../../../easymap/ContextHelp/ContextHelp';
import { createLightningConfig } from './lightningConfig';
import { LightningEntity } from '../../../types/lightning';

interface LightningExplorerProps {
  className?: string;
  initialPosition?: { x: number; y: number };
  initialSize?: { width: number; height: number };
  onClose?: () => void;
  isWindowed?: boolean;
  windowTitle?: string;
  resizable?: boolean;
  draggable?: boolean;
}

const LightningExplorer: React.FC<LightningExplorerProps> = (props) => {
  const { isFetchingUserInfo, isLoggedIn } = useFusionAuth();

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
  const defaultPosition = isMobile ? { x: 5, y: 5 } : { x: 150, y: 120 };
  const defaultSize = isMobile
    ? { width: window.innerWidth - 10, height: window.innerHeight - 10 }
    : { width: 1300, height: 700 };

  const baseConfig = createLightningConfig();

  if (isFetchingUserInfo) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading user context...</div>;
  }

  return (
    <ConfigurableBaseExplorer<LightningEntity>
      key="lightning-explorer"
      config={baseConfig}
      isAuthenticated={isLoggedIn}
      isWindowed={props.isWindowed ?? true}
      initialPosition={props.initialPosition ?? defaultPosition}
      initialSize={props.initialSize ?? defaultSize}
      resizable={props.resizable ?? true}
      draggable={props.draggable ?? true}
      showCloseButton={true}
      showMinimizeButton={true}
      windowTitle={props.windowTitle || 'Lightning Explorer'}
      onWindowClose={props.onClose}
      className={`lightning-explorer ${props.className || ''}`}
      customToolbar={<div className="lightning-help-toolbar"><ContextHelp title='Help with Lightning Data' context='lightning-help' /></div>}
    />
  );
};

export default LightningExplorer;
